<template>
  <div
    class="section"
    style="background-image: url('img/bg_4.jpg'); background-size: cover; background-position: top center; min-height: 700px;"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-10 ml-auto mr-auto">
          <div class="row collections">
            <div class="col-md-6">
              <img src="img/bg6.jpg" class="img-raised" />
              <img src="img/bg11.jpg" alt="" class="img-raised" />
            </div>
            <div class="col-md-6">
              <img src="img/bg7.jpg" alt="" class="img-raised" />
              <img src="img/bg8.jpg" alt="" class="img-raised" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput, Button } from '@/components';

export default {
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  }
};
</script>
<style></style>
